import { combineReducers } from 'redux';
import story from './story';
import user from './user';
import vis from './vis';

export default combineReducers({
    story,
    user,
    vis
});